import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { OrdersApiService } from "src/app/api/orders-api.service";
import { ArticleType, OrderItem, OrderItemStatus } from "src/app/model/order/order";
import { NewOrderStoreService } from "src/app/new-order/new-order-store-service.service";
import { i18nService } from "src/app/service-utils/i18n.service";
import { CartService } from "../cart/cart.service";
import { MessageService } from "../message/message.service";

@Component({
    selector: 'app-save-discard-order-dialog',
    templateUrl: './save-discard-order-dialog.component.html',
    styleUrls: ['./save-discard-order-dialog.component.scss']
  })
  export class SaveDiscardOrderDialogComponent {
  
    constructor(
      public dialogRef: MatDialogRef<SaveDiscardOrderDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public i18nService: i18nService,
      private cartService: CartService,
      private ordersApiService: OrdersApiService,
      private router: Router,
      private messages: MessageService,
      private newOrderStoreService: NewOrderStoreService
    ) {
    }

    cancel(): void {
      this.dialogRef.close();
    }
  
    saveAndGoToHome(): void {
      this.newOrderStoreService.setCopyTrialLensRight(undefined);
      this.newOrderStoreService.setCopyTrialLensLeft(undefined);

      this.router.navigate(['/home']);
      this.dialogRef.close();
      this.saveNewLensesAndItems();
    }

    discardAndGoToHome() {
      this.newOrderStoreService.setCopyTrialLensRight(undefined);
      this.newOrderStoreService.setCopyTrialLensLeft(undefined);
      
      this.router.navigate(['/home']);
      this.dialogRef.close();
    }

    private saveNewLensesAndItems() {
      let saveLenses: OrderItem[] = [];
      this.cartService.getCartItems().pipe(map(orderItems => orderItems.filter(orderItem => orderItem.isNew === true || orderItem.isUpdate === true))).subscribe(orderItems => saveLenses = orderItems);
      this.ordersApiService.updateCart({orderItems: saveLenses}).subscribe(response => {
        if(response.success) {
          this.messages.info("newOrder.messages.lensAdded");
          this.cartService.markLensesAsSaved();
        }
      });
    }
  
  }